import { Route } from "react-router-dom";
import AppSections from "../utils/AppSections";
import ProtectedRoute from "./ProtectedRoute";
import CollectionsList from "../ui/collections/CollectionsList";
import CollectionAddEdit from "../ui/collections/CollectionAddEdit";
import CollectionDetails from "../ui/collections/CollectionDetails";
import Collections from "../ui/collections/Collections";

const CollectionsRoutes = (
  <Route
    path={AppSections.COLLECTIONS}
    element={
      <ProtectedRoute>
        <Collections />
      </ProtectedRoute>
    }
  >
    <Route path="/collections/" element={<CollectionsList />} />
    <Route path="create" element={<CollectionAddEdit />} />
    <Route path=":id/view" element={<CollectionDetails />} />
    <Route path=":id/edit" element={<CollectionAddEdit />} />
  </Route>
);

export default CollectionsRoutes;
